import { ApiType } from "@gymflow/common";
import { TaskDTO } from "@gymflow/types";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { leadQueryKeys } from "../lead";
import { memberQueryKeys } from "../member";
import { deadlineDatesToUtc } from "./deadlineDatesToUtc";
import { taskQueryKeys } from "./taskQueryKeys";

export function useTaskCreate(
  {
    api,
    tz,
  }: {
    api: ApiType;
    tz: string;
  },
  mutationOpts?: UseMutationOptions<TaskDTO, unknown, { [k: string]: any }>,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newTask: { [k: string]: any }) => {
      const newFields = {
        ...newTask,
        ...deadlineDatesToUtc(newTask, tz),
      };

      return (await api.taskApi.create(newFields)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: memberQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.list() });
    },
    ...mutationOpts,
  });
}
